import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import RoundButton from 'Components/UI/RoundButton';
import Title from 'Components/ComponentLibrary/Atoms/Text/Title';
import Subtitle from 'Components/ComponentLibrary/Atoms/Text/Subtitle';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  subtitle: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  button: {
    margin: theme.spacing(2, 'auto'),
  },
});

const Content = ({
  className,
  classes,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Title
        className={classes.title}
        text={'Page Not Found'}
        align={'center'}
        test={'page-not-found-header'}
      />
      <Subtitle
        className={classes.subtitle}
        text={'The data for this page was not found. Click below to navigate back to the dashboard'}
        align={'center'}
      />
      <RoundButton
        className={classes.button}
        color="primary"
        disableElevation
        variant="contained"
        href={'/'}
      >
        {'Go to Dashboard'}
      </RoundButton>
    </Box>
  );
};

Content.defaultProps = {
  className: '',
};

Content.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Content);
